<!--取消周特价图片备份-->
<template>
  <div class="container stairs ac-bg" :id="'nav' + 0">
    <!-- <TopBanner></TopBanner> -->

    <Search></Search>
    <HomeNav></HomeNav>
    <RightFlex></RightFlex>
    <!-- 商品显示区域 -->
    <div class="content public-container" style="padding-top: 30px;">
      <!-- 通知公告 -->
      <div class="message-wrap">
        <div class="message-in">
          <div class="message-in-1">
            <img src="static\img\index\img\message.png" alt="图片破损">
            <p>通知公告：</p>
          </div>
          <div class="message-in-1-wrap">
            <Carousel
              style="width:100%"
              :autoplay="messageList && messageList.length > 1"
              :autoplay-speed="3000"
              v-model="valueCarousel"
              arrow="never"
              dots="none"
              loop
              @click.native="handleCarouselClick">
              <CarouselItem
                style="width: 400px;margin-right: 20px;"
                v-for="(item, inx) in messageList"
                :key="inx"
                :data-index="inx">
                <div class="message-in-1-wrap-cas">
              <span
                class="message-in-over"
                :title="item.title"
                :data-url="item.url"
                :data-item="JSON.stringify(item)">
                {{ item.title }}
              </span>
                  <span class="message-in-time">{{ item.create_time }}</span>
                </div>
              </CarouselItem>
            </Carousel>
          </div>
          <div class="message-in-1">
            <router-link to="/News">
              <span class="message-in-hover message-in-more" @click="toPersonal">查看更多></span>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 秒杀 -->
      <!-- <div class="seckill stairs" v-if="(seckillGoodList && seckillGoodList.length > 0)">
        <div class="placeholderArea" :id="'nav' + 1"></div>
        <div class="seckill-wrap">
          <div class="seckill-head">
            <div class="seckill-head-leftTitle">限时秒杀</div>
            <div class="count-down">
              <Icon type="ios-time" style="margin-right: 14px;" size="27" />
              <div class="count-down-title" v-if="curSeckillData.type === 1">距离开始倒计时：</div>
              <div class="count-down-title" v-if="curSeckillData.type === 2">剩余时间：</div>
              <div class="count-down-hour">
                <div class="circle1 ">{{ day ? day : 0 }}</div> &nbsp;天&nbsp;
                <div class="circle1 ">{{ hour ? hour : 0 }}</div> &nbsp;:&nbsp;
                <div class="circle2 ">{{ minute ? minute : 0 }}</div> &nbsp;:&nbsp;
                <div class="circle3 ">{{ second ? second : 0 }}</div>
              </div>
            </div>
            <div style="display: flex;">
              <div class="next-seckill" @click="upIndex">
                <Icon type="ios-arrow-back" />上一场
              </div>
              <div class="next-seckill" style="margin-left: 40px;" @click.stop="curSeckillIndex++" @click="downIndex">
                下一场<Icon type="ios-arrow-forward" />
              </div>
              <router-link to="/Seckill">
                <span class="show-more" @click="toPersonal('秒杀专区')">查看更多></span>
              </router-link>
            </div>
          </div>
          <div class="seckill-content" @click="saveLine('秒杀专区')">
            <div class="swiper-container" v-if="curSeckillData">
              <div class="swiper-wrapper">
                <div class="swiper-slide swiper-item" v-for="(item, index) in curSeckillData.goods" :key="index">
                  <div class="seckill-item">
                    <router-link to="/Seckill">
                      <div class="seckill-item-img">
                        <img :src="item.picture || '../../static/img/goodsList/goods_default_img.jpg'"
                          :onerror="defaultGoodsImg" alt="图片破损" />
                      </div>
                      <div class="seckill-item-info">
                        <p class="seckill-item-intro">{{ item.goods_name }}</p>
                        <p class="seckill-item-spec">{{ '规格：' + item.specification }}</p>
                        <p class="seckill-item-loginPrice" style="margin-top: 10px;">
                          <span class="seckill-price text-danger">
                            <Icon type="social-yen"></Icon>{{ '￥' + item.skg_price }}/{{ item.unit }}
                            <span class="seckill-price-old">{{ item.original_price }}</span>
                          </span>
                        </p>
                        <div style="display:flex;align-items: center;">
                          <Progress :percent="item.jindu" style="width:180px" :stroke-width="16" status="active"
                            text-inside />
                          <img style="width:18px;height: 18px;margin-top: 10px;margin-left:15px"
                            v-if="Number(item.jindu < 100)" src="static/img/index/skill_jindu.png" alt="">
                          <Icon style="font-size:16px;color:#147A38;margin-top: 10px;margin-left:15px" v-else
                            type="ios-checkmark-circle" />
                        </div>

                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="swiper-scrollbar"></div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 秒杀end -->

      <!-- 秒杀 -->
      <div
        class="seckill2 stairs"
        v-if="seckillGoodList && seckillGoodList.length > 0"
      >
        <!-- 头部 -->
        <div class="seckill-head">
          <div class="seckill-icon">
            <img src="static/img/index/clock.png" />
          </div>
          <div class="seckill-text">{{ curSeckillData.sk_name || "" }}</div>
          <div class="count-down">
            <span class="count-down-hour">{{ countDownTime }}</span>
            <!-- <span class="count-down-hour">{{ seckillsHours }}</span>
            <span>:</span>
            <span class="count-down-minute">{{ seckillsMinutes }}</span>
            <span>:</span>
            <span class="count-down-seconds">{{ seckillsSeconds }}</span> -->
          </div>
          <div class="seckill-text-1">剩余抢购时间</div>
          <router-link to="/Seckill" class="seckill-more">进入秒杀</router-link>
          <div class="next-seckill" @click.stop="curSeckillIndex++" @click="downIndex">
            下一场秒杀
            <Icon type="ios-arrow-forward" />
          </div>
        </div>
        <!-- 内容 -->
        <div class="seckill-content">
          <!-- Swiper -->
          <div class="swiper-container" v-if="curSeckillData">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide swiper-item"
                v-for="(item, index) in curSeckillData.goods"
                :key="index"
              >
                <div class="seckill-item">
                  <router-link to="/Seckill">
                    <div class="seckill-item-img">
                      <img
                        :src="
                          item.picture ||
                          '../../static/img/goodsList/goods_default_img.jpg'
                        "
                        :onerror="defaultGoodsImg"
                        alt="图片破损"
                      />
                    </div>
                    <div class="seckill-item-info">
                      <p class="seckill-item-intro">{{ item.goods_name }}</p>
                      <p class="seckill-item-spec">{{ item.specification }}</p>
                      <p class="seckill-item-loginPrice" style="margin-top: 10px;">
                        <span class="seckill-price text-danger">
                          <Icon type="social-yen"></Icon>{{ '￥' + item.skg_price }}/{{ item.unit }}
                          <span class="seckill-price-old">{{ item.original_price }}</span>
                        </span>
                      </p>
                      <Progress :percent="item.jindu" :stroke-width="7" />
                      <!-- <div class="seck-between">
                        <div>已售：123</div>
                        <div>剩余：123</div>
                      </div> -->
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-scrollbar"></div>
          </div>
        </div>
      </div>
      <!-- 秒杀end -->
      <!--今日特价开始-->
      <div class="todayDeal-item stairs floor-1" style="padding-bottom: 16px;" v-if="dailyList.length!=0">
        <div class="placeholderArea" :id="'nav' + 7"></div>
        <div class="weekly-title">
          <div class="hot-content">
            <div class="weekly-title-logo">
              每周<span class="color acb-main">特价</span>
            </div>
            <div class="weekly-time">
              <div class="weekly-more" @click="saveLine('每周特价')">
                <router-link to="/DailyZone">
                  查看更多
                  <Icon type="ios-arrow-forward" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="week-items-bottom" @click="saveLine('每周特价')">
          <div class="weekly-other-item">
            <!--            <div class="week-hit" @click="saveLine('每周特价')">-->
            <!--              <router-link :to="dailyImg.ad_url || ''">-->
            <!--                <img :src="dailyImg.img_url" alt="" />-->
            <!--              </router-link>-->
            <!--            </div>-->
            <HomeShop
              priceProp="arrive_hand_price"
              v-for="(item, index) in dailyList"
              :key="index"
              :item="item"
              :goIndexDetail="goIndexDetail"
              :defaultGoodsImg="defaultGoodsImg"
              :goodsLabelSet="goodsLabelSet"
              :handleCollect="handleCollect"
              :collectParams="['weeklyIndexList.weeklyBottom', '每周特价']"
            />
            <div v-for="item in 5" :key="item-10" class="temp"></div>
          </div>
        </div>
      </div>

      <!--三个广告位-->
      <div class="weekly-item-prefecture stairs">
        <div class="weekly-pre-img" @click="saveLine('器械专区', 1)">
          <router-link to="/ApparatusZone">
            <img src="static\img\index\img\Bitmap Copy 9.png" alt="" />
          </router-link>
        </div>
        <div class="weekly-pre-img" @click="saveLine('诊所专区', 1)">
          <router-link to="/ClinicZone">
            <img src="static\img\index\img\Bitmap Copy 10.png" alt="" />
          </router-link>
        </div>
        <div class="weekly-pre-img" @click="saveLine('高毛专区', 1)">
          <router-link :to="{ path: '/GoodsList', query: { show_id: 37} }">
            <img src="static\img\index\img\Bitmap Copy 11.png" alt="" />
          </router-link>
        </div>
      </div>
      <!--三个广告位-->

      <!-- 清仓专区 -->
      <div class="clearance-area">
        <div class="placeholderArea" :id="'nav' + 4"></div>
        <div class="clearance-area-right">
          <div class="title">
            <p class="title1">品牌专区</p>
            <div class="weekly-more" @click="saveLine('品牌专区')">

              <router-link to="/BrandZone">
                查看更多
                <Icon type="ios-arrow-forward" />
              </router-link>
            </div>
          </div>
          <img class="title-img" @click="goBrandList()" :src="brandIndexBanner" alt="">
          <div class="content" @click="saveLine('品牌专区')">
            <div class="content-item" v-for="(item, index) in brandIndexList" :key="index">
              <img :title="item.name" @click="goBrandListDetail(item)" :src="item.img_url" alt="">
            </div>
            <div v-for="item in 5" :key="item - 10" class="temp2"></div>
          </div>
        </div>
        <div class="clearance-area-left">
          <div class="title">
            <p class="title1">效期专区</p>
            <div class="weekly-more" @click="saveLine('效期专区')">
              <router-link to="/GoodsList?show_id=38">
                查看更多
                <Icon type="ios-arrow-forward" />
              </router-link>
            </div>
          </div>
          <img class="title-img" @click="goClearZoom()" :src="clearZoomBanner" alt="">
          <div class="content bk-3" @click="saveLine('效期专区')">
            <div class="content-item" style="margin-top: 12px" v-for="(item, inx) in (clearRoomListData||[]).slice(0, 3)" :key="inx"
                 @click="goIndexDetail(item)">
              <div class="content-item-left">
                <img :src="item.goods_img ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </div>
              <div class="content-item-right">
                <p class="goods-zsm" v-if="item.is_zsm === 1">
                  <span class="badge">有追溯码</span>
                </p>

                <p class="content-item-right-p">
                  ¥ {{ item.selling_price }}
                  <span class="weekly-old-price" v-if="item.selling_price < item.original_price - 0">
                    <s>￥{{ item.original_price }}</s>
                  </span>
                </p>
                <p class="content-item-right-t" :title="item.goods_name">{{ item.goods_name }}</p>
                <p class="content-item-right-g">{{ item.specification }}</p>
              </div>
            </div>
            <!-- <div v-for="(item, inx) in 5" :key="inx - 10" class="temp3"></div> -->
          </div>
        </div>
      </div>
      <!-- 效期专区结束 -->

      <!-- 超值换购 -->
      <div class="todayDeal-item stairs floor-1">
        <!--头部-->
        <div class="placeholderArea" :id="'nav' + 2"></div>
        <div class="weekly-title">
          <div class="hot-content">
            <div class="weekly-title-logo">超值<span class="color acb-main">换购</span></div>
            <div class="weekly-time">
              <div class="weekly-more" @click="saveLine('超值换购')">
                <router-link to="/Promotion">
                  查看更多
                  <Icon type="ios-arrow-forward" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!--头部-->
        <!--内容-->
        <div class="change-item" @click="saveLine('超值换购')" v-if="supers && supers.length > 0">
          <div class="change-item-left">

            <div class="change-item-left-t" :title="supers[1] ? supers[1].goods_name : ''">{{ supers[0].goods_name }}
            </div>
            <!-- 新增追溯码标签 -->
            <p class="goods-zsm" v-if="supers[0].is_zsm === 1">
              <span class="badge">有追溯码</span>
            </p>
            <div class="change-item-left-a">{{ supers[0].specification }}</div>
            <div class="change-item-left-m">{{ supers[0].swap_msg }}</div>
            <div class="change-item-left-p">¥ {{ supers[0].selling_price }}</div>
            <orderBtn @click="goIndexDetail(supers[0])" />
            <img class="change-item-left-i" :src="supers[0].goods_img ||
              '../../../static/img/goodsList/goods_default_img.jpg'
              " :onerror="defaultGoodsImg" alt="图片破损" />
          </div>
          <div class="change-item-left " v-show="supers[1]" style="margin-left: 10px;">
            <div class="change-item-left-t" :title="supers[1] ? supers[1].goods_name : ''">{{ supers[1] ?
              supers[1].goods_name : '' }}</div>
            <!-- 新增追溯码标签 -->
            <p class="goods-zsm" v-if="supers[1].is_zsm === 1">
              <span class="badge">有追溯码</span>
            </p>
            <div class="change-item-left-a">{{ supers[1] ? supers[1].specification : '' }}</div>
            <div class="change-item-left-m">{{ supers[1].swap_msg }}</div>
            <div class="change-item-left-p">¥ {{ supers[1] ? supers[1].selling_price : '' }} </div>
            <orderBtn @click="goIndexDetail(supers[1])" />
            <img class="change-item-left-i" :src="supers[1] ? supers[1].goods_img : '' ||
              '../../../static/img/goodsList/goods_default_img.jpg'
              " :onerror="defaultGoodsImg" alt="图片破损" />
          </div>
          <div class="change-item-right">
            <div class="change-item-right-t" v-show="supers[2]">
              <div style="width: 147px;">
                <p class="change-item-right-ti" :title="supers[2] ? supers[2].goods_name : ''">{{ supers[2] ?
                  supers[2].goods_name : '' }}</p>
                <!-- 新增追溯码标签 -->
                <p class="goods-zsm" v-if="supers[2].is_zsm === 1">
                  <span class="badge">有追溯码</span>
                </p>
                <p class="change-item-right-g">{{ supers[2] ? supers[2].specification : '' }}</p>
                <div class="change-item-left-m">{{ supers[2].swap_msg }}</div>
                <p class="change-item-right-p">¥ {{ supers[2] ? supers[2].selling_price : '' }}</p>
                <orderBtn @click="goIndexDetail(supers[2])" :height="'30px'" :width="'120px'" />
              </div>
              <div class="change-item-right-img">
                <img :src="supers[2] ? supers[2].goods_img : '' ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </div>
            </div>
            <div class="change-item-right-t" v-show="supers[3]" style="margin-top:10px;">
              <div style="width: 147px;">
                <p class="change-item-right-ti" :title="supers[3] ? supers[3].goods_name : ''">{{ supers[3] ?
                  supers[3].goods_name : '' }}</p>
                <!-- 新增追溯码标签 -->
                <p class="goods-zsm" v-if="supers[3].is_zsm === 1">
                  <span class="badge">有追溯码</span>
                </p>
                <p class="change-item-right-g">{{ supers[3] ? supers[3].specification : '' }}</p>
                <div class="change-item-left-m">{{ supers[3].swap_msg }}</div>
                <p class="change-item-right-p">¥ {{ supers[3] ? supers[3].selling_price : '' }}</p>
                <orderBtn @click="goIndexDetail(supers[3])" :height="'30px'" :width="'120px'" />
              </div>
              <div class="change-item-right-img">
                <img :src="supers[3] ? supers[3].goods_img : '' ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </div>
            </div>
          </div>
        </div>
        <div class="empty" v-else>
          <img src="static\img\personal\nothing.png" />
          <p>暂时没有商品看看其他的吧~</p>
        </div>

        <!--内容-->

      </div>
      <!-- 超值换购 -->


      <!-- 新品上架 -->
      <div class="newGoods">
        <div class="placeholderArea" :id="'nav' + 3"></div>
        <div class="todayDeal-item">
          <div class="weekly-title ">
            <div class="hot-content" style="width: 820px;">
              <div class="weekly-title-logo">新品上架</div>
              <div class="newGoods-page">
                <div class="pageIcon1" :class="{ 'disable': currentPage == 1 }" @click="changePage(currentPage - 1)"
                     style="margin-right: 20px;"></div>
                <div class="pageIcon" :class="{ 'disable': currentPage == totalPages }"
                     @click="changePage(currentPage + 1)"></div>
                <div class="weekly-more" @click="saveLine('新品上架')" style="padding-left: 20px;">
                  <router-link to="/newGoods">
                    查看更多
                    <Icon type="ios-arrow-forward" />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="newGoods-content">
            <Spin fix v-if="newGoodsSpin"></Spin>
            <div class="box-wrap" v-for="(item, index) in newGoodsData" :key="index" @click="goIndexDetail(item)">
              <div class="box-img">
                <img :src="item.goods_img ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
              </div>
              <div>
                <div class="change-item-right-ti" :title="item.goods_name">{{ item.goods_name }}</div>
                <p class="goods-zsm" v-if="item.is_zsm === 1">
                  <span class="badge">有追溯码</span>
                </p>
                <div class="change-item-right-g">{{ item.specification }}</div>
                <div class="change-item-right-p">¥ {{ item.selling_price }}</div>
                <div @click="saveLine('新品上架')">
                  <orderBtn />
                </div>
              </div>
            </div>
            <div class="empty" v-if="!(newGoodsData && newGoodsData.length > 0)">
              <img src="static\img\personal\nothing.png" />
              <p>暂时没有商品看看其他的吧~</p>
            </div>
          </div>

        </div>
      </div>
      <!--      <div class="new-goods">-->
      <!--        <div class="placeholderArea" :id="'nav' + 3"></div>-->
      <!--        <div class="ng-content">-->
      <!--            <div class="ngc-left">-->
      <!--              <img v-if="newGoodsImg.img_url" :src="newGoodsImg.img_url" />-->
      <!--              <img v-else src="static\img\index/img\Bitmap Copy 4.png" />-->
      <!--            </div>-->
      <!--            <div class="ngc-right">-->
      <!--            <Spin fix v-if="newGoodsSpin"></Spin>-->
      <!--              <div class="ngcr-li" v-for="(item, index) in newGoodsData" :key="index">-->
      <!--                <HomeShop-->
      <!--                  :item="item"-->
      <!--                  :goIndexDetail="goIndexDetail"-->
      <!--                  :defaultGoodsImg="defaultGoodsImg"-->
      <!--                  :goodsLabelSet="goodsLabelSet"-->
      <!--                  :handleCollect="handleCollect"-->
      <!--                  :collectParams="['weeklyIndexList.weeklyBottom', '新品上架']"-->
      <!--                  noStyle-->
      <!--                />-->
      <!--                <div class="weekly-more" @click="saveLine('新品上架')" style="padding-left: 20px;">-->
      <!--                  <router-link to="/newGoods">-->
      <!--                    查看更多-->
      <!--                    <Icon type="ios-arrow-forward" />-->
      <!--                  </router-link>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div class="ngcr-ept" v-for="l in 3" :key="l - 4"></div>-->
      <!--              <div class="empty" style="width: 100%;" v-if="!(newGoodsData && newGoodsData.length > 0)">-->
      <!--                <img src="static\img\personal\nothing.png" />-->
      <!--                <p>暂时没有商品看看其他的吧~</p>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--      </div>-->
      <!-- 新品上架结束 -->
    </div>

    <!--单品包邮-->
    <div class="todayDeal-item stairs" v-if="freeGoodsList && freeGoodsList.length > 0" style="position: relative;">
      <div class="placeholderArea" :id="'nav' + 6"></div>
      <div class="weekly-title">
        <div class="hot-content">
          <div class="weekly-title-logo">单品包邮</div>
          <div class="weekly-time">
            <div class="weekly-more" @click="saveLine('单品包邮')">
              <router-link to="/sigMail">
                查看更多
                <Icon type="ios-arrow-forward" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="week-items-bottom" @click="saveLine('单品包邮')">
        <div class="weekly-other-item" v-if="freeGoodsList.length > 0">
          <HomeShop
            v-for="(item, index) in freeGoodsList"
            :key="index"
            :item="item"
            :goIndexDetail="goIndexDetail"
            :defaultGoodsImg="defaultGoodsImg"
            :goodsLabelSet="goodsLabelSet"
            :handleCollect="handleCollect"
            :collectParams="['weeklyIndexList.weeklyBottom', '单品包邮']"
          />
          <div v-for="item in 5" :key="item-10" class="temp"></div>
        </div>
        <div class="empty" v-else>
          <img src="static\img\personal\nothing.png" />
          <p>暂时没有商品看看其他的吧~</p>
        </div>
      </div>
    </div>
    <!--热销推荐-->
    <div style="position: relative;" @click="saveLine('热销推荐')">
      <div class="placeholderArea" :id="'nav' + 5"></div>
      <Recommend></Recommend>
    </div>
    <!--今日特价-->


    <!--左侧悬浮框-->
    <div class="floor">
      <div class="floor-nav">
        <ul class="floor-left-ul">
          <li class="nav-list-item" v-for="item in tabs" :key="item.id"><a href="javascript:;"
                                                                           :class="{ active: chooseIndex == item.id }" @click="anchorPoint(item.id)"> {{ item.title }} </a></li>
          <!-- <li class="nav-list-item active"  v-if="(seckillGoodList && seckillGoodList.length > 0)">限时秒杀</li>
            <li class="nav-list-item">超值换购</li>
            <li class="nav-list-item">新品上架</li>
            <li class="nav-list-item">效期专区</li>
            <li class="nav-list-item">热销推荐</li> -->
          <!-- <li class="nav-list-item">组合套餐</li>
            <li class="nav-list-item">热销推荐</li> -->
        </ul>
      </div>
    </div>
    <!--左侧悬浮框-->
    <BackTop></BackTop>
    <!--首页弹出框-->
    <IndexPopup :indexVisible.sync="indexPopup" :popupData="popupData"></IndexPopup>
    <!--首页弹出框-->
    <Collect :CollectModel.sync="CollectPopup"></Collect>
    <NoCollect :NoCollectModel.sync="NoCollectPopup"></NoCollect>
    <div v-if="lottery_show" class="lottery_btn" >
      <img @click="goToLottery"  src="static\img\index\img\cj_btn_1.gif" alt="抽奖"/>
    </div>

    <!-- 在抽奖按钮之前或之后添加预约活动图标 -->
    <div v-if="reservationActivity && isReservationOpen" class="reservation_btn">
      <!-- 预约活动图标 -->
      <div class="reservation-icon"
           @click="handleReservation"
           @dblclick="handleCancelReservation"
           :class="{ 'reserved': isReservationReserved }">
        <div class="icon-container">
          <img :src="reservationActivity.activity_icon"
               :alt="reservationActivity.activity_name"
               class="activity-icon original-size" />
          <!-- 预约成功提示 -->
          <div v-if="showReservationSuccessTip" class="success-tip">预约成功</div>
        </div>

        <div class="close-btn" @click="closeReservationActivity">
          <Icon type="ios-close" size="16" />
        </div>
<!--        <div class="activity-name">{{ reservationActivity.activity_name }}</div>-->
        <div class="activity-name">{{ isReservationReserved ? '预约成功' : '点击预约哟' }}</div>
      </div>

    </div>



  </div>
</template>

<script>
import TopBanner from "@/components/nav/TopBanner.vue";
import Search from "@/components/Search";
import HomeNav from "@/components/nav/HomeNav";
import RightFlex from "@/components/nav/RightFlex";
import BackTop from "@/components/nav/BackTop";
import Recommend from "@/components/public/Recommend";
import IndexPopup from "@/components/popup/IndexPopup";
import orderBtn from "@/components/components/orderBtn.vue"
import HomeShop from './HomeComponents/HomeShop.vue'
import store from "@/vuex/store";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import $ from "jquery";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import {
  getIndexSeckill,
  getIndexCenter,
  getBrandList,
  getWeeklyList,
  getIndexBulletFrame,
  getIndexfreeShippingGoods,
  getDailySpecial,
  getNewImg,
  getBrandDiscount,
  getIndexPackagelist,
  indexCosmetics
} from "@/api/index";
import { getGoodsList } from "@/api/goods";
import { defaultGoodsLabelSet } from "@/components/nav/staticData";
import { collection } from "@/api/goods";
import Collect from "@/components/popup/Collect";
import NoCollect from "@/components/popup/NoCollect";
import { isEmpty } from "@/utils";
import { getRecommend } from "@/api/commonApi";
import { behaviorcollect, lineLocal } from '@/api/apiPot.js'
import { getIndexTop } from "@/api/index";
export default {
  name: "Index",
  data() {
    return {
      // 新增预约活动相关数据
      reservationActivity: null,
      isReservationReserved: false,
      isReservationOpen: false,
      showReservationSuccessTip: false,
      reservationSuccessTipTimer: null,
      reservationClickTimer: null,

      valueCarousel: 0,
      messageList: [],
      clearRoomListData: [],
      tabs:[],
      // tabs: [{ title: '首页', id: 0 }, { title: '每周特价', id: 7 }, { title: '超值换购', id: 2 }, { title: '新品上架', id: 3 }, { title: '效期专区', id: 4 }, { title: '热销推荐', id: 5 }],
      chooseIndex: 0,
      newGoodsSpin: false,
      currentPage: 1,
      itemsPerPage: 4,
      newGoodsData: [],
      newGoodsDataRes: [],
      newGoodsImg: {},
      setIntervalObj: null,
      setIntervalWeekly: null,
      weekValue: 0, //天天特价value
      weekSetting: {
        arrow: "never",
        autoplay: true,
        autoplaySpeed: 3000
      },
      hotValue: 0, //热销商品value
      hotSetting: {
        arrow: "never",
        autoplay: true,
        autoplaySpeed: 3000
      },
      freeValue: 0, //包邮商品value
      freeSetting: {
        arrow: "never",
        autoplay: true,
        autoplaySpeed: 3000
      },
      value2: 0,
      setting: {
        arrow: "never",
        autoplay: true,
        autoplaySpeed: 3000
      },
      sideCart: false,
      defaultGoodsImg:
        'this.src="' +
        require("../../static/img/goodsList/goods_default_img.jpg") +
        '"',
      goodsList: [],
      seckillGoodList: [], //接口秒杀列表
      curSeckillData: {}, //当前秒杀数据
      curSeckillIndex: 0, //秒杀索引
      curSeckillIndex2: 0, //秒杀索引
      indexCenterList: {
        /*  bottomL:[],
        bottomR:[]*/
      }, //首页中间层
      hotGoodsList: {
        banner: [],
        goodsL: [],
        goodsR: [],
        goodsBottom: []
      }, //
      /*  freeGoodsList: {
          banner: [],
          goodsL: [],
          goodsR: [],
          goodsBottom: []
        },*/
      freeGoodsListLength1: "",
      freeGoodsListLength2: "",
      goodsLabelSet: defaultGoodsLabelSet,
      newList: [], //新品推荐
      newListBanner: "", //新品左侧大图
      brandIndexList: [], //首页品牌列表
      brandIndexBanner: "", //首页品牌左侧大图
      brandIndexBannerUrl: '',//首页效期专区url
      weeklyIndexList: {
        weeklyTop: [],
        weeklyBottom: []
      }, //首页每周特价列表
      weeklyType: 1, //切换每周特价中西药 1为西药 2为中药 默认为1
      drugsList: [], //好药推荐列表
      drugsListBanner: "", //好药推荐右侧大图
      indexPopup: false, //首页弹窗
      popupData: {},
      timer: null, //秒杀定时器
      countDownTime: "",
      popupImg: "",
      weekLyCountDownDay: "",
      weekLyCountDownHour: "",
      weekLyCountDownMin: "",
      weekLyCountDownSec: "",
      weekLyTimer: null,
      CollectPopup: false, //收藏弹出框
      NoCollectPopup: false, //取消收藏弹出框
      seckillStartTime: -1,
      dailyList: [],//今日特价列表
      dailyImg: {},
      brandDiscountList: {
        banner: [],
        goodsL: [],
        goodsR: [],
        goodsBottom: []
      }, //品牌折扣列表
      freeGoodsList: [],//单品包邮列表
      packageList: [],//组合套餐列表
      supers: [],
      clearZoomBanner: '',//效期专区banner
      goClearZoomUrl: '',//效期专区banner url
      userInfo: {},
      hour: '',
      minute: '',
      second: "",
      day: '',
      lottery_show:false
    };
  },
  created() {
    this.loadSpecialOffer();
    this.loadCarouselItems();
    if (!isEmpty(window.sessionStorage.getItem("userName"))){
      this.vailLottery();
      // 新增：获取预约活动信息
      this.fetchReservationActivity();
    }

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.$store.dispatch("getNavbarData");
    const father = this;
    this.setIntervalObj = setInterval(function () {
      father.REDUCE_SECKILLS_TIME();
    }, 1000);
    const weekTime = this;
    this.setIntervalWeekly = setInterval(function () {
      weekTime.REDUCE_WEEKLY_SPECIAL_TIME();
    }, 1000);

    /*右侧悬浮框效果*/
    $(".online-service").on({
      mouseover: function () {
        $(".call-num").show();
      },
      mouseout: function () {
        $(".call-num").hide();
      }
    });

    /*右侧悬浮框效果*/
    indexCosmetics().then(res => {
      this.clearZoomBanner = res.data.banner.img_url
      this.goClearZoomUrl = res.data.banner.ad_url
    })
    this.showMessage()
    this.clearZoomList()
    this.newGoodsList()
    this.SwapList()// 换购
    // this.indexList();
    this.seckillList();
    this.indexBrandList();
    /*this.weeklyList();*/
    this.indexImg();
    this.freeShippingList();
    this.recommendList();
    this.dailySpecialList();
    this.discountList();
    this.indexPackageList();
    setTimeout(() => {
      if (this.seckillGoodList && this.seckillGoodList.length > 0) {
        this.tabs.splice(1, 0, { title: '限时秒杀', id: 1 })
      }
    }, 2000)
  },
  watch: {
    curSeckillIndex: {
      handler(newVal, oldVal) {
        let _this = this;
        if (this.curSeckillIndex > this.seckillGoodList.length - 1) {
          this.curSeckillIndex = this.seckillGoodList.length - 1;
        }
        this.curSeckillData = this.seckillGoodList[this.curSeckillIndex];

        clearInterval(_this.timer);
        this.seckillStartTime = new Date(
          this.curSeckillData.now_time
        ).getTime();
        // 切换时立即计算
        /*  this.curSeckillData.map(item => {*/
        let time = this.curSeckillData.type == 1 ? this.curSeckillData.start_time : this.curSeckillData.end_time;
        this.countDownTime = this.countDown(
          this.seckillStartTime, //这里改成now_time
          time
        );
        _this.timer = setInterval(() => {
          _this.countDownTime = _this.countDown(
            this.seckillStartTime, //这里改成now_time
            time
          );
        }, 1000);

        /* })*/



      },
      deep: true
    }
  },
  methods: {
    goToLottery(){
      this.saveLine('幸运抽奖')
      this.$router.push({
        path: '/Lottery'
      })
    },
    // vailLottery(){
    //     this.$http.get('/luckdraw/index').then(res=>{
    //         this.lottery_show = res.data.check_status
    //     })
    // },
    //抽奖验证
    vailLottery() {
      this.$http.get('/luckdraw/index').then(res => {
        this.lottery_show = !!res.data; // 有数据时为 true，否则为 false
      })
    },
    // 新增：关闭预约活动
    closeReservationActivity() {
      this.isReservationOpen = false;
    },
    // 新增：获取预约活动信息
    async fetchReservationActivity() {
      try {
        const response = await this.$http.get('/userInfo/getReservationActivity');
        const { activity, is_reserved, is_open } = response.data;

        this.reservationActivity = activity;
        this.isReservationReserved = is_reserved;
        this.isReservationOpen = is_open;
      } catch (error) {
        console.error('获取预约活动失败:', error);
      }
    },

    // 新增：处理预约点击
    async handleReservation() {
      // 清除之前的定时器
      if (this.reservationClickTimer) {
        clearTimeout(this.reservationClickTimer);
      }

      // 设置定时器，如果在300ms内没有第二次点击，则执行单击逻辑
      this.reservationClickTimer = setTimeout(() => {
        this.performReservation();
      }, 300);
    },

    // 新增：处理双击取消预约
    async handleCancelReservation() {
      // 清除之前的定时器
      if (this.reservationClickTimer) {
        clearTimeout(this.reservationClickTimer);
      }

      if (!this.reservationActivity) {
        this.$Message.warning('暂无预约活动');
        return;
      }

      if (!this.isReservationReserved) {
        this.$Message.info('当前未预约，无法取消');
        return;
      }

      try {
        const response = await this.$http.post('/userInfo/cancelReservation', {
          activity_id: this.reservationActivity.id
        });

        // 使用接口返回的data字段作为提示信息
        this.$Message.success(response.data || '取消预约成功');
        this.isReservationReserved = false;
      } catch (error) {
        this.$Message.error(error.message || '取消预约失败');
      }
    },

    // 新增：执行预约逻辑
    async performReservation() {
      if (!this.reservationActivity) {
        this.$Message.warning('暂无预约活动');
        return;
      }

      if (this.isReservationReserved) {
        // 如果已预约，提示用户双击取消
        this.$Message.info('已预约，双击图标取消预约');
        return;
      }

      try {
        const response = await this.$http.post('/userInfo/reserveActivity', {
          activity_id: this.reservationActivity.id
        });

        // 使用接口返回的data字段作为提示信息
        this.$Message.success(response.data || '预约成功');
        this.isReservationReserved = true;

        // 显示预约成功提示
        this.showReservationSuccessTip = true;

        // 清除之前的定时器
        if (this.reservationSuccessTipTimer) {
          clearTimeout(this.reservationSuccessTipTimer);
        }

        // 3秒后隐藏提示
        this.reservationSuccessTipTimer = setTimeout(() => {
          this.showReservationSuccessTip = false;
        }, 3000);
      } catch (error) {
        this.$Message.error(error.message || '预约失败');
      }
    },

    saveLine(e, x) {
      // setLineData({ source_type: x || 2, source_info: e })
      lineLocal({ source_type: x || 2, source_info: e })
    },
    goBrandListDetail(item) {
      //  跳转品牌单独列表页面

      this.$router.push({
        path: "/BrandList",
        query: {
          brand_id: item.id
        }
      });
    },
    toPersonal(e) {
      // setLineData({ source_type: 2, source_info: e })
      lineLocal({ source_type: 2, source_info: e })
      this.$router.push('/personal/MyMessages')
    },
    // 修复公告轮播点击
    handleCarouselClick(event) {
      const target = event.target;
      if (target.classList.contains('message-in-over')) {
        const itemData = target.getAttribute('data-item');
        if (itemData) {
          const item = JSON.parse(itemData);
          this.goNoticeDetails(item);
        }
      }
    },
    goNoticeDetails(item) {
      // 通知公告详情跳转

      // /goodsDetail
      // this.$router.push({
      //     path: "/goodsDetail",
      //     query: { id: item.goods_id }
      // });
      window.open(this.$router.resolve({
        path: "/News/NewsDetails",
        query: { art_id: item.id }
      }).href, "_blank");

    },
    showMessage() {
      getIndexTop().then(res => {
        this.messageList = res.data.message
      })
    },
    clearZoomList() {
      getGoodsList({ show_id: 38, is_ad: 1 }).then(res => {
        this.newGoodsSpin = false
        this.clearRoomListData = res.data.result.data.length > 6 ? res.data.result.data.slice(0, 6) : res.data.result.data
      }).catch(err => {
        this.newGoodsSpin = false
        this.$Message.error(err)
      })
    },
    newGoodsList() {
      this.newGoodsSpin = true
      getGoodsList({ show_id: 30, is_ad: 1 }).then(res => {
        this.newGoodsSpin = false
        this.newGoodsDataRes = res.data.result.data
        this.newGoodsSpin = false
        if (this.newGoodsDataRes.length > 4) {
          this.newGoodsData = this.newGoodsDataRes.slice(0, 4)
        } else {
          this.newGoodsData = this.newGoodsDataRes
        }
      }).catch(err => {
        this.newGoodsSpin = false
        this.$Message.error(err)
      })
      getNewImg().then(res => {
        this.newGoodsImg = res.data[0] || {}
      })
    },
    SwapList() {// 超值换购列表
      // this.spinLoading = true;
      this.$https
        .get("/index/buySwapDiscount", { page: this.page })
        .then((res) => {
          this.supers = [...res.data.data];
          // this.total = res.data.total;
          // this.show_img = res.data.img_pc;
          // if (this.supers.length == 0) {
          //   /*商品数据为空时，显示空页面*/
          //   this.emptyPage = true;
          // } else {
          //   this.emptyPage = false;
          // }
          // this.spinLoading = false;
        });
    },
    handleScroll() {
      const scrollY = window.scrollY;

      this.tabs.forEach((section) => {
        const sectionElement = document.querySelector('#nav' + section.id);
        const sectionTop = sectionElement.getBoundingClientRect().top + scrollY;

        if (scrollY >= sectionTop + -170) {
          this.chooseIndex = section.id;
        }
      });
    },
    anchorPoint(index) {
      document.querySelector('#nav' + index).scrollIntoView({
        behavior: "smooth"
      });
      this.chooseIndex = index;
      // 点击之后要做的事
    },
    changePage(page) {
      if (page < 1) {
        this.$Message.warning('已经是第一页了');
      }
      if (page > this.totalPages) {
        this.$Message.warning('已经是最后一页了');
      }
      if (page >= 1 && page <= this.totalPages) {
        this.newGoodsSpin = true
        setTimeout(() => {
          _this.newGoodsSpin = false
        }, 200)
        let _this = this
        this.currentPage = page;
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        this.newGoodsData = this.newGoodsDataRes.slice(startIndex, endIndex);
      }
    },
    recommendList() {
      /**为你推荐 */
      let _this = this;
      getRecommend()
        .then(res => {
          this.goodsList = res.data;
        })
        .catch(err => {
        });
    },
    goIndexDetail(item) {
      window.open(
        this.$router.resolve({
          path: '/goodsDetail',
          query: { id: item.goods_id }
        }).href,
        '_blank'
      )
      // this.$router.push({
      //   path: item.ad_url
      //   /* query: { id: item.goods_id }*/
      // });
      // 跳转新页面
      /* window.open(this.$router.resolve({ path: item.ad_url }).href, "_blank");*/
    },
    goPackageDetail(item) {
      // 跳转组合套餐页面
      window.open(
        this.$router.resolve({
          path: '/goodsDetail',
          query: { id: item.package_goods_id }
        }).href,
        '_blank'
      )
    },

    indexImg() {
      /**首页弹出框图片 */
      let _this = this;
      getIndexBulletFrame({ type: 1 })
        .then(res => {
          if (
            !isEmpty(res.data.BulletFrame) &&
            !isEmpty(res.data.BulletFrame.img_url)
          ) {
            _this.popupData = res.data.BulletFrame;
            // 未登录就一直弹出  已登录且关闭过一次就不弹了
            if (!this.userInfo.user_name || this.indexPopState + "" === "0")
              _this.indexPopup = true;
          } else {
            // this.indexPopup = false
          }
        })
        .catch(err => {
        });
    },
    weeklyList() {
      /**首页每周特价列表*/
      let _this = this;
      getWeeklyList({ type: this.weeklyType })
        .then(res => {
          this.weeklyIndexList = res.data.chosen;
          console.log('==========', this.weeklyIndexList)
          let weeklyIndexList = res.data.chosen;
          _this.weeklyIndexList.weeklyTop = weeklyIndexList.lists.slice(0, 2);
          _this.weeklyIndexList.weeklyBottom = weeklyIndexList.lists.slice(
            2,
            7
          );
          clearInterval(_this.weekLyTimer);
          let weekLyCountDownTime = _this.countDown(
            null,
            weeklyIndexList.end_time,
            1
          );
          _this.weekLyCountDownDay = weekLyCountDownTime.day;
          _this.weekLyCountDownHour = weekLyCountDownTime.hour;
          _this.weekLyCountDownMin = weekLyCountDownTime.minute;
          _this.weekLyCountDownSec = weekLyCountDownTime.second;
          _this.weekLyTimer = setInterval(() => {
            let weekLyCountDownTime = _this.countDown(
              null,
              weeklyIndexList.end_time,
              1
            );
            _this.weekLyCountDownDay = weekLyCountDownTime.day;

            _this.weekLyCountDownHour = weekLyCountDownTime.hour;
            _this.weekLyCountDownMin = weekLyCountDownTime.minute;
            _this.weekLyCountDownSec = weekLyCountDownTime.second;
          }, 1000);
        })
        .catch(err => {
        });
    },
    westernGoods() {
      /**每周特价切换为西药*/
      $(".weekly-classify-ul li").toggleClass("active");
      this.weeklyType = 1;
      this.weeklyList();
    },
    chineseGoods() {
      /**每周特价切换为中药*/
      $(".weekly-classify-ul li").toggleClass("active");
      this.weeklyType = 2;
      this.weeklyList();
    },
    // indexList() {
    //   let _this = this;
    //   getIndexSpecial()
    //     .then(res => {
    //       this.drugsList = res.data.lists;
    //       this.drugsListBanner = res.data.banner;
    //       if (this.drugsList.length > 0) {
    //         this.$nextTick(() => {
    //           this.hanldswiper();
    //         });
    //       }

    //     })
    //     .catch(err => {
    //     });
    // },
    hanldswiper() {
      /*好药推荐轮播*/
      var swiperGoods = new Swiper(".good-rec-content .swiper-container", {
        slidesPerView: 4, // 每页显示几个slide
        spaceBetween: 0, // slide的间距px
        followFinger: false, //
        speed: 1000, // 速度
        mousewheel: true, // 鼠标滚轮控制
        loop: $(".good-rec-content .swiper-slide").length > 2, // 循环
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        scrollbar: {
          el: ".good-rec-content .swiper-scrollbar",
          dragSize: 30
        }
      });
      swiperGoods.scrollbar.$el.css("height", "3px");
      swiperGoods.scrollbar.$dragEl.css("background", "#147A38");
    },
    freeShippingList() {
      /**首页包邮商品列表*/
      let _this = this;
      getIndexfreeShippingGoods()
        .then(res => {
          this.freeGoodsList = res.data.freegoods;
          if (this.freeGoodsList.length > 0) {
            if (this.seckillGoodList && this.seckillGoodList.length > 0) {
              this.tabs.splice(6, 0, { title: '单品包邮', id: 6 })
            } else {
              this.tabs.splice(5, 0, { title: '单品包邮', id: 6 })
            }

          }
          /*  let freeGoodsList = res.data;
          _this.freeGoodsListLength1 = freeGoodsList.banner.length;
          _this.freeGoodsListLength2 = freeGoodsList.freegoods.length;
            _this.freeGoodsList.banner = freeGoodsList.banner;
            _this.freeGoodsList.goodsL = freeGoodsList.freegoods.slice(0, 1);
            _this.freeGoodsList.goodsR = freeGoodsList.freegoods.slice(1, 2);
            _this.freeGoodsList.goodsBottom = freeGoodsList.freegoods.slice(2, 12);*/
        })
        .catch(err => {
        });
    },
    /** 跳转详情 */
    toDetal(item) {
      // this.$router.push({
      //   path: "/goodsDetail",
      //   query: { id: item.goods_id }
      // });
      // 新开页面跳转
      window.open(
        this.$router.resolve({
          path: '/goodsDetail',
          query: { id: item.goods_id }
        }).href,
        '_blank'
      )
    },
    dailySpecialList() {
      /**首页今日特价列表*/
      let _this = this;
      getDailySpecial()
        .then(res => {
          let li = res.data.goods || []
          this.dailyList = li.slice(0, 10);
          this.dailyImg = res.data.img[0] || {}

          if(this.dailyList.length!=0){
            this.tabs=
              [{ title: '首页', id: 0 },
                { title: '每周特价', id: 7 },
                { title: '超值换购', id: 2 },
                { title: '新品上架', id: 3 },
                { title: '效期专区', id: 4 },
                { title: '热销推荐', id: 5 }]
          }else{
            this.tabs=
              [{ title: '首页', id: 0 },
                { title: '超值换购', id: 2 },
                { title: '新品上架', id: 3 },
                { title: '效期专区', id: 4 },
                { title: '热销推荐', id: 5 }]
          }
        })
        .catch(err => {
        });
    },
    discountList() {
      /**首页品牌折扣列表*/
      let _this = this;
      getBrandDiscount()
        .then(res => {
          /*this.brandDiscountList = res.data;*/
          let brandDiscountList = res.data;
          _this.brandDiscountList.banner = brandDiscountList.banner;
          _this.brandDiscountList.goodsL = brandDiscountList.lists.slice(0, 1);
          _this.brandDiscountList.goodsR = brandDiscountList.lists.slice(1, 2);
          _this.brandDiscountList.goodsBottom = brandDiscountList.lists.slice(2, 7);
        })
        .catch(err => {
        });
    },
    indexPackageList() {
      /**首页组合套餐列表*/
      let _this = this;
      getIndexPackagelist()
        .then(res => {
          this.packageList = res.data;
        })
        .catch(err => {
        });
    },

    indexBrandList() {
      /**首页品牌专区列表*/
      let _this = this;
      getBrandList()
        .then(res => {
          this.brandIndexList = res.data.lists;
          this.brandIndexBanner = res.data.banner.img_url;
          this.brandIndexBannerUrl = res.data.banner.ad_url;
        })
        .catch(err => {
        });
    },
    getLabels(labels) {
      if (labels) {
        return labels.split(",").length > 4
          ? labels.split(",").slice(3)
          : labels.split(",");
      } else {
        return ['0']
      }
    },
    seckillList() {
      /**秒杀列表*/
      let _this = this;
      getIndexSeckill()
        .then(res => {
          this.seckillGoodList = res.data;
          if (this.seckillGoodList.length > 0) {
            // 排序
            this.seckillGoodList.sort(function (a, b) {
              return b.type - a.type;
            });
            this.curSeckillData = this.seckillGoodList[0];
            clearInterval(_this.timer);
            this.seckillStartTime = new Date(
              this.curSeckillData.now_time
            ).getTime();
            /*type等于1表示秒杀未开始  等于2表示正在进行中*/
            let time = this.curSeckillData.type == 1 ? this.curSeckillData.start_time : this.curSeckillData.end_time;
            this.countDownTime = _this.countDown(
              this.seckillStartTime, //这里改成now_time
              time
            );
            _this.timer = setInterval(() => {
              _this.countDownTime = _this.countDown(
                this.seckillStartTime, //这里改成now_time
                time
              );
            }, 1000);
            /*     if(this.curSeckillData.type==1){
                   /!*type等于1表示秒杀未开始  等于2表示正在进行中*!/
                   this.countDownTime = _this.countDown(
                     this.seckillStartTime, //这里改成now_time
                     this.curSeckillData.start_time
                   );
                   _this.timer = setInterval(() => {
                     _this.countDownTime = _this.countDown(
                       this.seckillStartTime, //这里改成now_time
                       this.curSeckillData.start_time
                     );
                   }, 1000);
                 }else {
                   this.countDownTime = _this.countDown(
                     this.seckillStartTime, //这里改成now_time
                     this.curSeckillData.end_time
                   );
                   _this.timer = setInterval(() => {
                     _this.countDownTime = _this.countDown(
                       this.seckillStartTime, //这里改成now_time
                       this.curSeckillData.end_time
                     );
                   }, 1000);
                 }*/

            this.$nextTick(() => {
              this.handleSeckillSwiper();
            });
          }
        })
        .catch(err => {
        });
    },
    upIndex() {
      //点击上一场秒杀
      if (this.curSeckillIndex <= 0) {
        /* this.$message.warning("这是第一场秒杀哦~");*/
        this.curSeckillIndex = 0;
        return
      } else {
        this.curSeckillIndex--
      }

      this.curSeckillData = {};
      this.seckillList();
      if (this.seckillGoodList.length > 0) {
        this.$nextTick(() => {
          this.handleSeckillSwiper();
        });
      }

    },
    downIndex() {
      //点击下一场秒杀
      if (this.curSeckillIndex == this.seckillGoodList.length) {
        /* this.$message.warning("这是最后一场秒杀哦~");*/
        return
      }
    },
    handleSeckillSwiper() {
      if (this.seckillGoodList && this.seckillGoodList.length > 0) {
        /*秒杀轮播*/
        var swiper = new Swiper(".seckill-content .swiper-container", {
          slidesPerView: 4, // 每页显示几个slide
          spaceBetween: 0, // slide的间距px
          followFinger: false, //
          speed: 1000, // 速度
          mousewheel: true, // 鼠标滚轮控制
          loop: $(".seckill-content .swiper-slide").length > 2, // 循环
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          scrollbar: {
            el: ".seckill-content .swiper-scrollbar",
            dragSize: 30
          },
          observer: true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents: true//修改swiper的父元素时，自动初始化swiper
        });
        swiper.scrollbar.$el.css("height", "3px");
        swiper.scrollbar.$el.css("marginTop", "10px")
        swiper.scrollbar.$dragEl.css("background", "#147A38");
      }
    },
    time() {
      /*倒计时*/
      var that = this;
      var interval = setInterval(function timestampToTime() {
        var date = new Date(结束的时间戳) - new Date();
        //new Date当前的时间戳，也可以换成自定义的时间戳
        if (date > 0) {
          let time = date / 1000;
          // 获取时、分、秒,毫秒
          that.hou =
            parseInt((time % (60 * 60 * 24)) / 3600) < 10
              ? "0" + parseInt((time % (60 * 60 * 24)) / 3600)
              : parseInt((time % (60 * 60 * 24)) / 3600);
          that.min =
            parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10
              ? "0" + parseInt(((time % (60 * 60 * 24)) % 3600) / 60)
              : parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          that.sec =
            parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10
              ? "0" + parseInt(((time % (60 * 60 * 24)) % 3600) % 60)
              : parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          that.ssec = parseInt(((date % (60 * 60 * 24)) % 3600) / 60) % 10;
        } else {
          //活动已结束，全部设置为'00'
          (that.day = "00"),
            (that.hou = "00"),
            (that.min = "00"),
            (that.sec = "00");
        }
      }, 100);
    },
    /*   goIndexDetail(item) {
         // TODO 首页详情跳转
         // this.$router.push({
         //   path: item.ad_url
         //   /!* query: { id: item.goods_id }*!/
         // });
         // 跳转新页面
         window.open(this.$router.resolve({ path: item.ad_url }).href, "_blank");
       },*/
    goBrandList() {
      //  跳转品牌单独列表页面
      this.$router.push({
        path: this.brandIndexBannerUrl,
      });
    },
    goClearZoom() {
      //  跳转品牌单独列表页面
      this.$router.push({
        path: this.goClearZoomUrl,
      });
    },
    /**秒杀倒计时 0-秒杀倒计时  1 每周特价倒计时*/
    countDown(startTime, endtime, type = 0) {
      // 是否需要计算秒杀开始时间？
      // const seconds = Math.round(
      //   (new Date(endtime).getTime() - new Date().getTime()) / 1000
      // );
      // 新修改为取服务器倒计时时间
      let seconds = 0;
      if (!startTime) {
        seconds = Math.round(
          (new Date(endtime).getTime() - new Date().getTime()) / 1000
        );
      } else {
        seconds = Math.round(
          (new Date(endtime).getTime() - this.seckillStartTime) / 1000
        );
        if (seconds <= 0) {
          this.seckillList();
        }
      }
      if (seconds <= 0) {
        clearInterval(this.timer);
        return "秒杀已结束";
      }
      const second = seconds % 60;
      const minutes = (seconds - second) / 60;
      const minute = minutes % 60;
      const hours = (minutes - minute) / 60;
      const hour = hours % 24;
      const day = (hours - hour) / 24;
      const res =
        (day * 24 + hour < 10 ? "0" + (day * 24 + hour) : day * 24 + hour) +
        " : " +
        (minute < 10 ? "0" + minute : minute) +
        " : " +
        (second < 10 ? "0" + second : second);
      // console.log(day + '天 ' + hour + '小时 ' + minute + '分钟 ' + second + '秒 ')

      this.seckillStartTime += 1000;

      if (type === 0) {
        this.day = day
        this.hour = (hour < 10 ? "0" + hour : hour)
        this.minute = (minute < 10 ? "0" + minute : minute)
        this.second = (second < 10 ? "0" + second : second)
        return res
      } else {
        return {
          day: day,
          hour: hour < 10 ? "0" + hour : hour,
          minute: minute < 10 ? "0" + minute : minute,
          second: second < 10 ? "0" + second : second
        };
      }

    },
    ...mapActions([
      "signOut",
      "isLogin",
      "loadSpecialOffer",
      "loadCarouselItems",
      "loadShoppingCart",

    ]),
    ...mapMutations(["REDUCE_SECKILLS_TIME", "REDUCE_WEEKLY_SPECIAL_TIME"]),
    openCart() {
      if (this.sideCart == false) {
        $(".floorRight").css({ right: "250px" });
        this.sideCart = true;
      } else {
        this.sideCart = false;
        $(".floorRight").css({ right: "1%" });
      }
    },
    close() {
      this.sideCart = false;
      $(".floorRight").css({ right: "1%" });
    },
    // 收藏	1添加2取消
    handleCollect(item, type, index, dataType, xxx) {
      if (type == 1) {
        this.saveLine(xxx)
        behaviorcollect({ goods_id: item.goods_id })
      }
      collection({
        goods_id: item.goods_id,
        type: type
      })
        .then(res => {
          if (res.code + "" !== "200") return;
          this.$store.dispatch("goods/setRightRefresh", Math.random() * 10);

          if (type == 1) {
            this.CollectPopup = true;
            switch (dataType) {
              case "weeklyIndexList.weeklyTop":
                item.favorites_type = 1;
                this.$set(this.weeklyIndexList.weeklyTop, index, item);

                break;
              case "weeklyIndexList.weeklyBottom":
                item.favorites_type = 1;
                this.$set(this.weeklyIndexList.weeklyBottom, index, item);

                break;
              case "hotGoodsList.goodsL":
                item.favorites_type = 1;
                this.$set(this.hotGoodsList.goodsL, index, item);

                break;
              case "hotGoodsList.goodsR":
                item.favorites_type = 1;
                this.$set(this.hotGoodsList.goodsR, index, item);

                break;
              case "hotGoodsList.goodsBottom":
                item.favorites_type = 1;
                this.$set(this.hotGoodsList.goodsBottom, index, item);

                break;

              default:
                break;
            }
          } else {
            this.NoCollectPopup = true;
            this.collectState = true;
            switch (dataType) {
              case "weeklyIndexList.weeklyTop":
                item.favorites_type = 0;
                this.$set(this.weeklyIndexList.weeklyTop, index, item);

                break;
              case "weeklyIndexList.weeklyBottom":
                item.favorites_type = 0;
                this.$set(this.weeklyIndexList.weeklyBottom, index, item);

                break;
              case "hotGoodsList.goodsL":
                item.favorites_type = 0;
                this.$set(this.hotGoodsList.goodsL, index, item);

                break;
              case "hotGoodsList.goodsR":
                item.favorites_type = 0;
                this.$set(this.hotGoodsList.goodsR, index, item);

                break;
              case "hotGoodsList.goodsBottom":
                item.favorites_type = 0;
                this.$set(this.hotGoodsList.goodsBottom, index, item);

                break;

              default:
                break;
            }
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    }
  },
  computed: {
    ...mapState(["seckills", "weekly", "computer", "eat"]),
    ...mapState({
      indexPopState: state => state.app.indexPopState
    }),
    ...mapGetters([
      "seckillsHours",
      "seckillsMinutes",
      "seckillsSeconds",
      "weeklyHours",
      "weeklyMinutes",
      "weeklySeconds",
      "userName",
      "userAllData"
    ]),
    totalPages() {
      return Math.ceil(this.newGoodsDataRes.length / this.itemsPerPage);
    }
  },
  components: {
    TopBanner,
    Search,
    HomeNav,
    RightFlex,
    BackTop,
    Recommend,
    IndexPopup,
    Collect,
    NoCollect,
    orderBtn,
    HomeShop,
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
    clearInterval(this.setIntervalObj);
    clearInterval(this.setIntervalWeekly);
    clearInterval(this.timer);
    clearInterval(this.weekLyTimer);
    // 新增：清理预约活动定时器
    if (this.reservationSuccessTipTimer) {
      clearTimeout(this.reservationSuccessTipTimer);
    }
    if (this.reservationClickTimer) {
      clearTimeout(this.reservationClickTimer);
    }
    /*销毁滚动监听*/
    window.removeEventListener("scroll", this.handleScroll);
  },
  // store
};
</script>

<style lang="less" scoped>
.ac-bg {
  background: linear-gradient(315deg, #F9092F 0%, #ff3a40 100%);
  .acb-main {
    color: #333 !important;
  }
}
.container {
  background-color: #F8F8F8;
}

.message-wrap {
  width: 1200px;
  margin: 35px auto;
  margin-bottom: 20px;
  width: 1200px;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(177, 177, 177, 0.2);
  border-radius: 10px;
  padding: 12px 16px 12px 16px;

  .message-in {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;


    .message-in-hover:hover {
      color: #147A38;
    }

    .message-in-1-wrap {
      width: 850px;
      display: flex;

      .message-in-1-wrap-cas {
        width: 100%;
        display: flex;

        .message-in-over {
          overflow: hidden; //块元素超出隐藏
          display: block;
          width: 240px;
          padding-left: 20px;
          text-overflow: ellipsis; //文本超出块元素时以省略号的形式显示
          white-space: nowrap; //规定段落中的文本不进行换行
        }

        .message-in-over:hover {
          color: #147A38;
          cursor: pointer;
        }

        .message-in-time {
          width: 150px;
          font-size: 12px;

          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666;
          padding-right: 30px;
          border-right: 1px solid #EFEFEF;
          // margin-right: 30px;
        }
      }
    }

    .message-in-1 {
      display: flex;
      align-items: center;
      cursor: pointer;


      .message-in-hover:hover {
        color: #147A38;
      }



      .message-in-more {
        color: #666;
        font-size: 20rpx;
        font-weight: 600;
        color: #111
      }

      img {
        width: 36px;
        height: 36px;
        margin-right: 10px;
      }

      p {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 21px;
      }


    }
  }
}

.content {
  width: 100%;
  margin: 0 auto;
}

.mt0 {
  margin-top: 0 !important;
}

/*标签*/
/*单促销标签*/
.pro-one {

  // display: none;
  .promotion-gm {
    width: 50px;
    height: 50px;
    background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
    box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
    font-size: 16px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-xp {}

  .promotion-zs {
    width: 62px;
    height: 62px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-hg {
    width: 62px;
    height: 62px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-ms {
    width: 62px;
    height: 62px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-xq {
    width: 66px;
    height: 64px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
    // display: none;
  }

  .promotion-tj {
    width: 64px;
    height: 63px;
    position: absolute;
    top: -4px;
    left: 10px;
    z-index: 10;
  }

  .promotion-txt {
    width: 140px;
    position: absolute;
    top: 8px;
    left: 70px;
    font-size: 12px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/*多促销标签*/
.pro-more {
  width: 100%;
  position: absolute;
  z-index: 4;

  .pro-other {
    display: inline-block;
    font-size: 12px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #666;
    box-sizing: border-box;
    padding: 5px 8px;
    width: 156px;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(216, 216, 216, 0.3);
    border-radius: 6px;
    position: relative;
    text-align: left;
    line-height: 14px;
  }

  .pro-other-1 {
    display: none;
  }

  .pro-other-1::after {
    content: "";
    position: absolute;
    left: 22px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-other-2 {
    display: none;
  }

  .pro-other-2::after {
    content: "";
    position: absolute;
    left: 39px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-other-3 {
    margin-left: -37%;
    display: none;
  }

  .pro-other-3::after {
    content: "";
    position: absolute;
    left: 62px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-other-4 {
    margin-left: -98%;
    display: none;
  }

  .pro-other-4::after {
    content: "";
    position: absolute;
    left: 120px;
    top: -5%;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
  }

  .pro-more-1 {
    width: 57px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background: url("/static/img/goodsList/pro_more_1.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    line-height: 26px;
  }

  .pro-more-1:hover .pro-other-1 {
    display: block;
  }

  .pro-more-2 {
    width: 82px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 38px;
    z-index: 9;
    background: url("/static/img/goodsList/pro_more_2.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    text-indent: 10px;
    line-height: 26px;
  }

  .pro-more-2:hover .pro-other-2 {
    display: block;
  }

  .pro-more-3 {
    width: 77px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 99px;
    z-index: 8;
    background: url("/static/img/goodsList/pro_more_3.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    text-indent: 7px;
    line-height: 26px;
  }

  .pro-more-3:hover .pro-other-3 {
    display: block;
  }

  .pro-more-4 {
    width: 81px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 148px;
    z-index: 7;
    background: url("/static/img/goodsList/pro_more_4.png") no-repeat;
    font-size: 12px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    text-indent: 19px;
    line-height: 26px;
  }

  .pro-more-4:hover .pro-other-4 {
    display: block;
  }
}

/*标签*/
/*首页悬浮框*/
.floor {
  position: fixed;
  left: 1%;
  top: 24.58%;
  z-index: 10;
  width: 100px;
  /*height: 280px;*/
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(196, 196, 196, 0.2);
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  text-align: center;
  // display: none;
  padding-bottom: 23px;

  .floor-left-ul li {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #666;
    line-height: 20px;
    padding-top: 23px;
    cursor: pointer;
  }

  .floor-left-ul li a:hover {
    color: #147A38;
  }

  .floor-left-ul li a {
    color: #666;
  }

  .floor-left-ul .active {
    color: #147A38;
  }
}

.floorRight {
  z-index: 10;
  position: fixed;
  right: 1%;
  top: 25%;
  width: 80px;
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(196, 196, 196, 0.2);
  border-radius: 10px;
  border: 1px solid #f0f0f0;

  .floorRight-ul {
    position: relative;

    li {
      margin-top: 16px;
      cursor: pointer;
      color: #666;

      a {
        color: #666;
      }
    }
  }

  .floorRight-ul li:hover .floorRight-txt {
    color: #147A38;
  }

  .call-num {
    position: absolute;
    top: 10%;
    right: 100%;
    width: 150px;
    height: 134px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(216, 216, 216, 0.3);
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    text-align: center;
    cursor: pointer;
    display: none;

    .call-icon {
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-left: 11px solid #fff;
      border-bottom: 10px solid transparent;
      position: absolute;
      top: 50px;
      right: -10px;
    }

    .call-img {
      width: 74px;
      height: 41px;
      margin: 14px auto auto auto;
    }

    .call-txt {
      font-size: 14px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      padding-top: 10px;
      padding-bottom: 6px;
    }

    .call-line {
      width: 10px;
      /* height: 1px;*/
      border-top: 1px solid #e2e2e2;
      margin: 0 auto;
    }

    .call-phoneNum {
      font-size: 16px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #147A38;
      line-height: 22px;
      padding-top: 6px;
    }
  }

  .call-num::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 50px;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    transform: rotate(-316deg);
    box-shadow: 3px -3px 3px rgba(216, 216, 216, 0.3);
  }

  .img {
    width: 18px;
    height: 22px;
    margin: 0 auto;
  }

  .img1 {
    background: url(/static/img/index/indexIcon.png) no-repeat -126px -51px;
  }

  .floorRight-ul li:hover .img1 {
    background: url(/static/img/index/indexIcon.png) no-repeat -90px -51px;
  }

  .img2 {
    background: url(/static/img/index/indexIcon.png) no-repeat -200px -51px;
  }

  .floorRight-ul li:hover .img2 {
    background: url(/static/img/index/indexIcon.png) no-repeat -164px -51px;
  }

  .img3 {
    background: url(/static/img/index/indexIcon.png) no-repeat -271px -51px;
  }

  .floorRight-ul li:hover .img3 {
    background: url(/static/img/index/indexIcon.png) no-repeat -235px -51px;
  }

  .img4 {
    background: url(/static/img/index/indexIcon.png) no-repeat -343px -51px;
  }

  .floorRight-ul li:hover .img4 {
    background: url(/static/img/index/indexIcon.png) no-repeat -307px -51px;
  }

  .img5 {
    background: url(/static/img/index/indexIcon.png) no-repeat -55px -85px;
  }

  .floorRight-ul li:hover .img5 {
    background: url(/static/img/index/indexIcon.png) no-repeat -19px -85px;
  }

  .img6 {
    background: url(/static/img/index/indexIcon.png) no-repeat -128px -85px;
  }

  .floorRight-ul li:hover .img6 {
    background: url(/static/img/index/indexIcon.png) no-repeat -92px -85px;
  }

  .img7 {
    background: url(/static/img/index/indexIcon.png) no-repeat -200px -85px;
  }

  .floorRight-ul li:hover .img7 {
    background: url(/static/img/index/indexIcon.png) no-repeat -164px -85px;
  }

  .floorRight-txt {
    font-size: 12px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #666;
    line-height: 17px;
    text-align: center;
  }
}

/*首页悬浮框*/

/*****************************秒杀专栏开始*****************************/
/*秒杀专栏*/
.seckill2 {
  width: 1200px;
  height: 350px;
  margin: 10px auto 20px auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  .seckill-head {
    width: 230px;
    height: 350px;
    background: linear-gradient( 315deg, #FF4260 0%, #E9A83A 100%);
    box-shadow: 0px 2px 6px 0px rgba(184,101,0,0.3);
    border-radius: 6px;
  }
  .seckill-icon {
    width: 71px;
    margin: 24px auto auto auto;
  }
  .seckill-icon img {
    width: 71px;
    height: 76px;
    margin: 0 auto;
    animation-name: shake-clock;
    animation-duration: 0.3s;
    animation-iteration-count: infinite; /*设置无线循环*/
  }
  /*定义闹钟震动动画关键帧*/
  @keyframes shake-clock {
    0% {
      transform: rotate(-8deg);
    }
    50% {
      transform: rotate(8deg);
    }
    100% {
      transform: rotate(-8deg);
    }
  }
  .seckill-text {
    font-size: 24px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    line-height: 33px;
    text-align: center;
    padding-top: 10px;
  }

  /*倒计时*/
  .count-down {
    font-size: 0;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 1px;
    text-align: center;
  }
  .count-down span {
    font-size: 36px;
  }
  .count-down-text {
    color: #fff;
  }
  .seckill-text-1 {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    padding-top: 10px;
  }
  .seckill-more {
    display: block;
    width: 150px;
    height: 36px;
    line-height: 36px;
    background: #ffc40f;
    box-shadow: 0px 2px 8px 0px rgba(200, 151, 0, 0.29);
    border-radius: 36px;
    text-align: center;
    color: #fff;
    margin: 26px auto auto auto;
  }
  .next-seckill {
    font-size: 14px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    padding-top: 17px;
    cursor: pointer;
  }

  .seckill-content {
    width: 959px;
    height: 350px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
    .swiper-container {
      width: 100%;
    }
    .swiper-slide {
      text-align: center;
    }
    .swiper-scrollbar {
      background: #f0f0f0;
    }
    .swiper-container-horizontal > .swiper-scrollbar {
      bottom: 15px;
    }
  }
  .swiper-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* flex-flow: row wrap;
     align-content: flex-start;*/
  }
  .seckill-item {
    /*flex: 0 0 25%;*/
    width: 225px;
    height: 350px;
    margin-left: 15px;
    cursor: pointer;
    .seckill-item-img {
      width: 165px;
      height: 140px;
      margin: 0 auto;
      overflow: hidden;
      background-size: 100% 100%;
      margin-top: 30px;
    }
    .seckill-item-img img {
      width: 165px;
      height: 140px;
      transition: margin-top 0.3s;
    }
    .seckill-item-img:hover img {
      margin-top: 6px;
      transition: margin-top 0.3s;
    }
  }
  .seckill-item-info {
    padding: 0 20px;
    text-align: left;
    .seckill-item-intro {
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      padding-top: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .seckill-item-spec {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      padding-top: 7px;
    }
    .seckill-item-noLogin {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      line-height: 20px;
      padding-top: 20px;
    }
    .seckill-item-loginPrice {}

    .seckill-item-num {
      margin-top: 5px;
      width: 200px;
      display: flex;
      justify-content: space-between;

      span {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666;
      }
    }

    .seckill-price {
      font-size: 18px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 600;
      color: #E9001F;
    }

    .seckill-price-old {
      margin-left: 10px;
      text-decoration-line: line-through;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #CCCCCC;
    }

    .seckill-old-price {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      line-height: 17px;
    }
    .seck-between {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      // background-color: red;
    }
  }
  .seckill-item-info /deep/ .ivu-progress-bg {
    background-color: #ff6161;
  }
  .seckill-item-info /deep/ .ivu-progress-inner {
    background-color: #ffe6e7;
  }
  .seckill-item-info /deep/ .ivu-progress {
    margin-top: 10px;
  }
}
.seckill /deep/ .swiper-slide {
  width: 225px;
  height: 350px;
}
/*****************************秒杀专栏结束*****************************/

/*****************************秒杀专栏开始*****************************/
/*秒杀专栏*/
.seckill {
  width: 1200px;
  // height: 350px;
  margin: 20px auto 20px auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative;

  .seckill-wrap {
    width: 100%;
    border: 2px solid #147A38;
    border-radius: 10px;
    padding: 14px 20px 14px 20px;
  }

  .seckill-head {
    width: 100%;
    height: 62px;
    border-bottom: 1px solid #E2E2E2;
    display: flex;
    justify-content: space-between;

    .seckill-head-leftTitle {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 62px;
    }
  }
  .seckill-head {
    width: 230px;
    height: 350px;
    background: linear-gradient(180deg, #ff6161 0%, #ff4353 100%);
    border-radius: 6px;
  }
  .seckill-icon {
    width: 71px;
    margin: 24px auto auto auto;
  }
  .seckill-icon img {
    width: 71px;
    height: 76px;
    margin: 0 auto;
    animation-name: shake-clock;
    animation-duration: 0.3s;
    animation-iteration-count: infinite; /*设置无线循环*/
  }
  /*定义闹钟震动动画关键帧*/
  @keyframes shake-clock {
    0% {
      transform: rotate(-8deg);
    }
    50% {
      transform: rotate(8deg);
    }
    100% {
      transform: rotate(-8deg);
    }
  }
  .seckill-text {
    font-size: 24px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    line-height: 33px;
    text-align: center;
    padding-top: 10px;
  }

  /*倒计时*/
  .count-down {
    font-size: 0;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 1px;
    text-align: center;
  }
  .count-down span {
    font-size: 36px;
  }
  .count-down-text {
    color: #fff;
  }
  .seckill-text-1 {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    padding-top: 10px;
  }
  .seckill-more {
    display: block;
    width: 150px;
    height: 36px;
    line-height: 36px;
    background: #ffc40f;
    box-shadow: 0px 2px 8px 0px rgba(200, 151, 0, 0.29);
    border-radius: 36px;
    text-align: center;
    color: #fff;
    margin: 26px auto auto auto;
  }
  .next-seckill {
    font-size: 14px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    padding-top: 17px;
    cursor: pointer;
  }

  .seckill-icon {
    width: 71px;
    margin: 24px auto auto auto;
  }

  .seckill-icon img {
    width: 71px;
    height: 76px;
    margin: 0 auto;
    animation-name: shake-clock;
    animation-duration: 0.3s;
    animation-iteration-count: infinite;
    /*设置无线循环*/
  }

  /*定义闹钟震动动画关键帧*/
  @keyframes shake-clock {
    0% {
      transform: rotate(-8deg);
    }

    50% {
      transform: rotate(8deg);
    }

    100% {
      transform: rotate(-8deg);
    }
  }

  .seckill-text {
    font-size: 24px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #ffffff;
    line-height: 33px;
    text-align: center;
    padding-top: 10px;
  }

  /*倒计时*/
  .count-down {
    // font-size: 0;
    // font-family: PingFangHK-Semibold, PingFangHK;
    // font-weight: 600;
    // color: #ffffff;
    // letter-spacing: 1px;
    text-align: center;
    font-size: 24px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #333333;
    letter-spacing: 1px;
    display: flex;
    line-height: 62px;
    align-items: center;

    .count-down-hour {
      display: flex;
      align-items: center;
      z-index: 1;

      .circle1 {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 50%;
        background: #F5F5F5;
        z-index: -1;
      }

      .circle2 {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 50%;
        background: #F5F5F5;
        z-index: -1;
      }

      .circle3 {
        width: 50px;
        height: 50px;
        line-height: 50px;
        border-radius: 50%;
        text-align: center;
        background: #F5F5F5;
        z-index: -1;
      }
    }
  }

  .count-down span {
    font-size: 24px;
  }

  .count-down-text {
    color: #fff;
  }

  .seckill-text-1 {
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    padding-top: 10px;
  }

  .seckill-more {
    display: block;
    width: 150px;
    height: 36px;
    line-height: 36px;
    background: #ffc40f;
    box-shadow: 0px 2px 8px 0px rgba(200, 151, 0, 0.29);
    border-radius: 36px;
    text-align: center;
    color: #fff;
    margin: 26px auto auto auto;
  }

  .show-more {

    font-size: 20rpx;
    font-weight: 600;
    color: #111;
    line-height: 62px;
    margin-left: 40px;
    cursor: pointer;
  }

  .show-more:hover {
    color: #147A38;
  }

  .switch-seckill {
    display: flex;
    justify-content: space-between;
    // margin: 17px 20px 0 20px;
  }

  .next-seckill {
    font-size: 14px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 500;
    color: #666;
    text-align: center;
    /*padding-top: 17px;*/
    cursor: pointer;
    line-height: 62px;
  }

  .seckill-content {
    width: 100%;
    height: 350px;
    background: #ffffff;
    // border-radius: 6px;
    // border: 1px solid #666;
    // box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);

    .swiper-container {
      margin-left: 20px;
      width: 100%;
    }

    .swiper-slide {
      /*text-align: center;*/
    }

    .swiper-scrollbar {
      margin-top: 10px;
      background: #f0f0f0;
    }

    .swiper-container-horizontal>.swiper-scrollbar {
      bottom: 15px;
    }
  }

  .swiper-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* flex-flow: row wrap;
     align-content: flex-start;*/
  }

  .seckill-item::after {
    position: absolute;
    top: 90px;
    right: 0;
    content: "";
    width: 1px;
    height: 180px;
    z-index: 9999999;
    background: #E2E2E2;
  }

  .seckill-item {
    /*flex: 0 0 25%;*/
    width: 225px;
    // height: 300px;
    // margin-left: 15px;
    // margin-top: 15px;
    cursor: pointer;
    // border-right: 1px solid #F2F2F2;
    position: relative;

    .seckill-item-img {
      max-width: 220px;
      height: 180px;
      --height: 140px;
      margin: 0 auto;
      overflow: hidden;
      background-size: 100% 100%;

      // margin-top: 30px;
      .seckill-item-img-lt {
        text-align: center;
        line-height: 50px;
        position: absolute;
        right: 20px;
        top: 15px;
        z-index: 2 important !;
        width: 50px;
        height: 50px;
        font-size: 16px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #FFFFFF;
        border-radius: 50%;
        background: linear-gradient(309deg, #DC1F41 0%, #ED2F43 100%);
        box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
      }
    }

    .seckill-item-img img {
      padding-top: 20px;
      max-width: 200px;
      height: 150px;
      transition: margin-top 0.3s;
    }

    .seckill-item-img:hover img {
      margin-top: 6px;
      transition: margin-top 0.3s;
    }
  }

  .seckill-item-info {
    .seckill-item-intro {
      font-size: 18px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 600;
      color: #111;
      /*padding-top: 20px;*/
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .seckill-item-price {
      .goods-price {
        font-size: 20px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #FA0000;
      }

      .goods-old-price {
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666;
        margin-left: 2px;
      }
    }

    .seckill-item-spec {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333;
      padding-top: 10px;
    }

    .seckill-item-noLogin {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      line-height: 20px;
      padding-top: 20px;
    }

    .seckill-item-loginPrice {}

    .seckill-item-num {
      margin-top: 5px;
      width: 200px;
      display: flex;
      justify-content: space-between;

      span {
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666;
      }
    }

    .seckill-price {
      font-size: 20px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 600;
      color: #E9001F;
    }

    .seckill-price-old {
      margin-left: 19px;
      text-decoration-line: line-through;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #CCCCCC;
    }

    .seckill-old-price {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      line-height: 17px;
    }
  }

  .seckill-item-info /deep/ .ivu-progress-bg {
    background-color: #FF6161;
  }

  .seckill-item-info /deep/ .ivu-progress-inner-text {
    font-size: 10px !important;
    height: 16px;
    line-height: 16px;
    vertical-align: baseline;
  }

  .seckill-item-info /deep/ .ivu-progress-inner {
    background-color: #F5F5F5;
  }

  .seckill-item-info /deep/ .ivu-progress {
    margin-top: 10px;
  }
}

.seckill /deep/ .swiper-slide {
  width: 225px;
  height: 350px;
}

/*****************************新品上市*****************************/
.newGoods {
  margin-top: 20px;
  padding-top: 5px;
  height: 540px;
  width: 100%;
  background: url('../../static/img/index/img/backgroun1.png') center center no-repeat;
  //background-size: calc(100% - 300px) auto; /* 宽度减少60px（左右各30px） */
  position: relative;

  .newGoods-page {
    display: flex;
    height: 62px;
    align-items: center;

    .pageIcon {
      width: 30px;
      height: 30px;
      background: url('../../static/img/index/img/right_un.png') no-repeat 50%;
      border-radius: 50%;
      opacity: 1;

    }


    .pageIcon:hover {
      width: 30px;
      height: 30px;
      background: url('../../static/img/index/img/right_hv.png') no-repeat 50%;
      background-size: cover;
      cursor: pointer;
      border-radius: 50%;
      transition: opacity 1s;
      opacity: 0.5;
    }

    .pageIcon1 {
      width: 30px;
      height: 30px;
      background: url('../../static/img/index/img/left_un.png') no-repeat 50%;
      border-radius: 50%;
      opacity: 1;

    }


    .pageIcon1:hover {
      width: 30px;
      height: 30px;
      background: url('../../static/img/index/img/left_hv.png') no-repeat 50%;
      background-size: cover;
      cursor: pointer;
      border-radius: 50%;
      transition: opacity 1s;
      opacity: 0.5;
    }

    .disable:hover {
      cursor: not-allowed;
    }
  }

  .newGoods-content {
    margin-top: -10px;
    padding: 10px;
    border-radius: 10px;
    background: white;
    position: relative;
    width: 820px;
    height: 384px;
    display: flex;
    justify-content: space-between;
    align-content: space-between;
    flex-wrap: wrap;

    .box-wrap {
      width: 400px;
      height: 182px;
      background: #FFFFFF;
      // box-shadow: 0px 2px 6px 0px rgba(193, 193, 193, 0.2);
      border-radius: 8px;
      padding: 20px;
      display: flex;

      .change-item-right-ti {
        width: 100%;
        height: 25px;
        font-size: 18px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        text-align: left;
        overflow: hidden !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
      }

      .change-item-right-g {
        margin-top: 5px;
        height: 20px;
        width: 100%;
        text-align: left;
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 400;
        color: #666;
        line-height: 20px;
      }

      .change-item-right-p {
        margin-top: 12px;
        margin-bottom: 15px;
        width: 100%;
        text-align: left;
        height: 27px;
        font-size: 20px;
        font-family: ArialMT;
        color: #FF0022;
        line-height: 23px;
      }

      .box-img {
        width: 180px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 152px;
          max-width: 152px;
        }
      }
    }
  }
}

.new-goods {
  margin-top: 20px;
  padding-top: 5px;
  width: 100%;
  height: 300px;
  position: relative;
  .ng-content {
    width: 1200px;
    height: 100%;
    margin: auto;
    display: flex;
    .ngc-left {
      width: 230px;
      height: 100%;
      background-color: #f2f2f2;
      flex-shrink: 0;
      img{
        height: 100%;
        width: 100%;
      }
    }
    .ngc-right {
      margin-left: 10px;
      height: 100%;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(220,220,220,0.3);
      border-radius: 6px;
      border: 1px solid rgba(220,220,220,0.3);
      flex: 1;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      img {
        width: 190px;
        height: 140px;
      }
      .ngcr-li {
        padding: 20px 25px 0;
        width: 239px;
        height: 300px;
        &:not(:nth-child(-n+2)) {
          border-left: 1px solid rgba(220,220,220,0.3);
        }
      }
      .ngcr-ept {
        width: 239px;
      }
    }
  }
}
/*****************************新品上市end*****************************/



/*****************************清仓专区*****************************/
.clearance-area {
  width: 1200px;
  margin: 30px auto 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;


  .weekly-more a {
    font-size: 20rpx;
    font-weight: 600;
    color: #111;
    line-height: 33px;
    cursor: pointer;

  }

  .weekly-more a:hover {
    color: #147A38;
  }



  .clearance-area-left {
    padding: 20px;
    width: 590px;
    height: 540px;
    background: #FFFFFF;
    box-shadow: 3px 3px 4px 3px rgba(193, 193, 193, 0.31);
    border-radius: 8px;

    .content-item {
      cursor: pointer;
      width: 169px;
      height: 80px;
      display: flex;

      .content-item-left {
        width: 80px;
        height: 80px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
          max-width: 80px;
        }
      }

      .content-item-right {
        width: 76px;
        text-align: left;

        .content-item-right-t {
          width: 100%;
          font-size: 12px;
          margin-top: 10px;
          height: 20px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #333333;
          overflow: hidden !important;
          white-space: nowrap !important;
          text-overflow: ellipsis !important;
        }

        .content-item-right-g {
          width: 100%;
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #A2A2A2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .content-item-right-p {
          margin-top: 5px;
          width: 100%;
          height: 17px;
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #FA0000;
          line-height: 17px;
        }
      }
    }
    .bk-3 {
      width: 100%;
      height: 255px;
      overflow: hidden;
      padding: 0 0 15px 0;
      .content-item {
        display: block;
        width: 169px;
        height: 184px;
        .content-item-left {
          width: 170px;
          height: 127px;
          margin-right: 10px;

          img {
            width: 100%;
            height: 100%;
            max-width: 169px;
          }
        }

        .content-item-right {
          width: 100%;
          text-align: left;

          .content-item-right-t {
            width: 100%;
            font-size: 16px;
            margin-top: 4px;
            height: 20px;
            font-family: PingFangHK-Regular, PingFangHK;
            font-weight: 400;
            color: #333333;
            overflow: hidden !important;
            white-space: nowrap !important;
            text-overflow: ellipsis !important;
          }

          .content-item-right-g {
            width: 100%;
            font-size: 12px;
            margin-top: 6px;
            font-family: PingFangHK-Regular, PingFangHK;
            font-weight: 400;
            color: #A2A2A2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .content-item-right-p {
            margin-top: 5px;
            width: 100%;
            height: 17px;
            font-size: 20px;
            font-family: PingFangHK-Regular, PingFangHK;
            font-weight: 400;
            color: #FA0000;
            line-height: 17px;
          }

          .weekly-old-price {
            font-size: 14px;
            color: #666;
            text-shadow: 0px 2px 6px rgba(220,220,220,0.3);
            line-height: 17px;
            padding-left: 10px;
          }
        }
      }

    }
  }

  .clearance-area-right {
    padding: 20px;
    padding: 20px;
    width: 590px;
    height: 540px;
    background: #FFFFFF;
    box-shadow: 3px 3px 4px 3px rgba(193, 193, 193, 0.31);
    border-radius: 8px;

    .content-item {
      width: 178px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      img {
        width: 114px;
        height: 76px;

      }
    }

    .content-item::after {
      content: "";
      position: absolute;
      top: 25px;
      right: 0;
      width: 2px;
      height: 50px;
      background: #F0F0F0;
      z-index: 1;
    }
  }

  .title {
    height: 50px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    align-items: end;
  }

  .title-img {
    height: 210px;
    width: 549px;
    border-radius: 10px;
    cursor: pointer;
  }

  .title1 {
    height: 50px;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 50px;
  }

  .content {
    width: 100%;
    height: 225px;
    overflow: hidden;
    padding: 30px 0 15px 0;
    display: flex;
    justify-content: space-between;
    align-content: space-between;
    flex-wrap: wrap;
  }
}

.content .content-item:nth-child(3n)::after,
.content .content-item:nth-child(6n)::after {
  display: none;
}

/*****************************清仓专区end*****************************/




/*****************************超值换购*****************************/
.change-item {
  width: 100%;
  margin: 0px auto;
  display: flex;

  .change-item-left {
    padding: 33px;
    width: 395px;
    height: 460px;
    background: #FFFFFF;
    box-shadow: 0px 3px 8px 0px rgba(193, 193, 193, 0.31);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .change-item-left-t {
      height: 40px;
      line-height: 40px;
      font-size: 28px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #000000;
      overflow: hidden !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
    }

    .change-item-left-a {
      width: 100%;
      height: 20px;
      font-size: 14px;
      margin-top: 10px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      text-align: center;
      line-height: 20px;
    }
    .change-item-left-m{
      padding: 0 30px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #333;
    }
    .change-item-left-p {
      text-align: center;
      width: 100%;
      height: 33px;
      font-size: 24px;
      margin-top: 16px;
      font-family: ArialMT;
      color: #FF0022;
      line-height: 28px;
      margin-bottom: 15px;
    }

    .change-item-left-i {
      margin-top: 20px;
      width: 279px;
      height: 219px;
    }
  }

  .change-item-right {
    margin-left: 10px;

    .change-item-right-t {
      padding: 30px;
      width: 390px;
      height: 225px;
      background: #FFFFFF;
      box-shadow: 0px 3px 8px 0px rgba(193, 193, 193, 0.31);
      border-radius: 8px;
      display: flex;

      .change-item-right-img {
        width: 180px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 160px;
          max-width: 160px;
        }
      }

      .change-item-right-ti {
        width: 100%;
        height: 33px;
        text-align: left;
        font-size: 24px;
        font-family: PingFangHK-Semibold, PingFangHK;
        font-weight: 600;
        color: #000000;
        line-height: 33px;
        overflow: hidden !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
      }

      .change-item-right-g {
        margin-top: 5px;
        height: 20px;
        width: 100%;
        text-align: left;
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666;
        line-height: 20px;
      }
      .change-item-left-m{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #333;
      }
      .change-item-right-p {
        margin-top: 12px;
        margin-bottom: 20px;
        width: 100%;
        text-align: left;
        height: 27px;
        font-size: 20px;
        font-family: ArialMT;
        color: #FF0022;
        line-height: 23px;
      }
    }
  }
}

/*****************************秒杀专栏结束*****************************/

/*****************************三个广告位*****************************/
.weekly-item-prefecture {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 15px;
  width: 1200px;
  margin: 0 auto 0 auto;

  .weekly-pre-img {
    width: 390px;
    height: 180px;
    margin-right: 15px;
    box-shadow: 0px 4px 8px 0px rgb(179 179 179 / 20%);


    img {
      cursor: pointer;
      width: 390px;
      height: 180px;
    }
  }

  .weekly-pre-img:last-child {
    margin-right: 0;
  }
}

/*****************************三个广告位*****************************/



/*****************************商品专栏开始*****************************/
.item-class {
  width: 100%;
  height: 470px;
  margin-top: 15px;
  background-color: #fff;
}

.item-class-head {
  width: 100%;
  height: 50px;
  background-color: #4488a7;
}

.item-class-eat-head {
  background-color: #ecb226;
}

.item-class-head ul {
  list-style: none;
  float: right;
  margin-right: 30px;
  line-height: 50px;
}

.item-class-head a {
  padding: 6px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6da6be;
  border: 1px solid #6da6be;
  text-decoration: none;
  color: #fff;
}

.item-class-eat-head a {
  background-color: #eeb955;
  border: 1px solid #eeb955;
}

.item-class-head a:hover {
  border: 1px solid #fff;
}

.item-class-head li {
  float: left;
}

.item-class-title {
  font-size: 25px;
  line-height: 50px;
  color: #fff;
  margin-left: 15px;
}

.item-class-content {
  width: 49%;
  cursor: pointer;
  border-right: 1px solid #ccc;
  margin-left: 0.9%;
  /*background-color: #cff;*/
  float: left;
}

.item-class-content:nth-child(odd) {
  border: none;
}

.item-content-top {
  width: 100%;
  height: 260px;
}

.item-big-img {
  width: 180px;
  height: 260px;
  overflow: hidden;
  float: left;
}

.item-big-img img {
  margin-left: 0px;
  transition: margin-left 0.3s;
}

.item-big-img:hover img {
  margin-left: -15px;
  transition: margin-left 0.3s;
}

.item-four-img {
  width: 303px;
  margin-left: 8px;
  float: left;
}

.item-four-detail img {
  margin-left: 0px;
  transition: margin-left 0.3s;
}

.item-four-detail:hover img {
  margin-left: -6px;
  transition: margin-left 0.3s;
}

.item-four-detail {
  width: 152px;
  height: 130px;
  margin-left: -1px;
  float: left;
}

.item-four-detail:first-child {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.item-four-detail:last-child {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.item-four-detail-text {
  width: 50px;
  margin-left: 5px;
  margin-top: 15px;
  float: left;
}

.item-four-detail-img {
  width: 96px;
  margin-top: 15px;
  overflow: hidden;
  float: left;
}

.item-four-detail-img img {
  margin-left: 5px;
  width: 90px;
}

.pt_bi_tit {
  font-weight: bold;
  font-size: 12px;
  color: #4488a7;
}

.pt_bi_tit-eat {
  color: #ecb127;
}

.pt_bi_promo {
  color: #00695c;
}

.item-content-bottom {
  width: 100%;
  margin-top: 8px;
}

.item-content-bottom-img {
  width: 156px;
  margin-right: 8px;
  overflow: hidden;
  float: left;
}

.item-content-bottom-img img {
  margin-left: 0px;
  transition: margin-left 0.3s;
}

.item-content-bottom-img:hover img {
  margin-left: -15px;
  transition: margin-left 0.3s;
}

/*****************************商品专栏结束*****************************/

/*****************************今日特价开始*****************************/
.todayDeal-item {
  width: 1200px;
  margin-top: 60px;
  margin: 0 auto;
  padding-bottom: 39px;
  position: relative;

  /*单促销标签*/
  .pro-one {

    // display: none;
    .promotion-gm {
      width: 50px;
      height: 50px;
      background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
      box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-xp {}

    .promotion-zs {
      width: 62px;
      height: 62px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-hg {
      width: 62px;
      height: 62px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-ms {
      width: 62px;
      height: 62px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-xq {
      width: 66px;
      height: 64px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-tj {
      width: 64px;
      height: 63px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
    }

    .promotion-txt {
      width: 140px;
      position: absolute;
      top: 8px;
      left: 70px;
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /*多促销标签*/
  .pro-more {
    width: 100%;
    position: absolute;
    z-index: 4;

    .pro-other {
      display: inline-block;
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      box-sizing: border-box;
      padding: 5px 8px;
      width: 156px;
      background: #fff;
      box-shadow: 0px 2px 4px 0px rgba(216, 216, 216, 0.3);
      border-radius: 6px;
      position: relative;
      text-align: left;
      line-height: 14px;
    }

    .pro-other-1 {
      display: none;
    }

    .pro-other-1::after {
      content: "";
      position: absolute;
      left: 22px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-other-2 {
      display: none;
    }

    .pro-other-2::after {
      content: "";
      position: absolute;
      left: 39px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-other-3 {
      margin-left: -37%;
      display: none;
    }

    .pro-other-3::after {
      content: "";
      position: absolute;
      left: 62px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-other-4 {
      margin-left: -98%;
      display: none;
    }

    .pro-other-4::after {
      content: "";
      position: absolute;
      left: 120px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-more-1 {
      width: 57px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background: url("/static/img/goodsList/pro_more_1.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      line-height: 26px;
    }

    .pro-more-1:hover .pro-other-1 {
      display: block;
    }

    .pro-more-2 {
      width: 82px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 38px;
      z-index: 9;
      background: url("/static/img/goodsList/pro_more_2.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      text-indent: 10px;
      line-height: 26px;
    }

    .pro-more-2:hover .pro-other-2 {
      display: block;
    }

    .pro-more-3 {
      width: 77px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 99px;
      z-index: 8;
      background: url("/static/img/goodsList/pro_more_3.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      text-indent: 7px;
      line-height: 26px;
    }

    .pro-more-3:hover .pro-other-3 {
      display: block;
    }

    .pro-more-4 {
      width: 81px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 148px;
      z-index: 7;
      background: url("/static/img/goodsList/pro_more_4.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      text-indent: 19px;
      line-height: 26px;
    }

    .pro-more-4:hover .pro-other-4 {
      display: block;
    }
  }

  .weekly-title {
    padding-bottom: 25px;
  }

  .hot-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 15px;
  }

  .weekly-title {
    .weekly-title-logo {
      font-size: 36px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 600;
      color: #333333;
      line-height: 56px;
      width: 188px;

      .color {
        color: #FE4354;
      }
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #ccc;
      margin-left: 15px;
      /*color: #333333;*/
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 20rpx;
        font-weight: 600;
        color: #111;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #147A38;
      }
    }
  }

  .weekly-classify {
    .weekly-classify-ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 28px 0;
    }

    .weekly-classify-ul li {
      padding-left: 20px;
      cursor: pointer;
    }

    .weekly-classify-ul li:hover {
      color: #147A38;
    }

    .weekly-classify-ul li.active {
      color: #147A38;
    }
  }

  .week-items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    /*  -webkit-box-pack: justify;
              -ms-flex-pack: justify;
              justify-content: space-between;*/
    .week-items-carousel {
      width: 715px;
      height: 280px;
      box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
      margin-right: 12px;
    }

    .week-items-carousel {}

    .week-items-carousel /deep/ .ivu-carousel-dots-inside {
      bottom: 20px;
    }

    .week-items-carousel /deep/ .ivu-carousel-dots li button {
      background: #147A38;
    }
  }

  .week-items-bottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .weekly-other-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    justify-content: space-between;
    align-content: space-between;
    .week-hit {
      width: 714px;
      height: 290px;
      background-color: #f0f0f0;
      border-radius: 6px;
      box-shadow: 0px 4px 8px 0px rgba(179, 179, 179, 0.2);
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }

}

.temp {
  width: 19%;
  height: 0;
  margin: 0;
}


/*****************************今日特价结束*****************************/
.temp2 {
  width: 178px;
  height: 0;
  margin: 0;
}

.temp3 {
  width: 169px;
  height: 0;
  margin: 0;
}

.placeholderArea {
  position: absolute;
  top: -170px;
}

.empty {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  // img {
  //   width: 618px;
  //   height: 454px;
  // }
  p {
    width: 100%;
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #666;
    text-align: center;
  }
}

.weekly-more a {
  font-size: 20rpx;
  font-weight: 600;
  color: #111;
  line-height: 33px;
  cursor: pointer;

}

.weekly-more a:hover {
  color: #147A38;
}

.rxtj {
  position: relative;
}
.lottery_btn{
  bottom: 30px;
  right: 0;
  display: block;
  cursor: pointer;
  position: fixed;
  z-index: 10;
  img{
    width: 120px;

  }
}
.goods-zsm .badge {
  display: inline-block;
  padding: 1px 4px; // 内边距控制椭圆大小
  font-weight: bold; // 加粗字体
  font-size: 12px;
  color: #147A38; // 文字颜色
  background-color: #e6f7ee; // 可选背景色
  border-radius: 30px; // 椭圆形状
  border: 1px solid #b2eec7; // 可选边框
}
//预约活动
/* 预约活动按钮样式 */
//.reservation_btn{
//  bottom: 30px; /* 与抽奖按钮对齐的位置 */
//  right: 120px;
//  display: block;
//  cursor: pointer;
//  position: fixed;
//  z-index: 10;
//}
.reservation_btn {
  bottom: 170px; /* 与抽奖按钮对齐的位置 */
  right: 0;
  display: block;
  cursor: pointer;
  position: fixed;
  z-index: 10;
  //padding: 10px; /* 添加内边距 */
  //border-radius: 8px; /* 添加圆角 */
  //box-shadow: 0 2px 8px rgba(0,0,0,0.15); /* 添加阴影 */
}

.reservation-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  width: 160px;
}

.close-btn {
  position: absolute;
  top: -4px;
  right: 70px;
  width: 20px;
  height: 20px;
  background: #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-size: 12px;
  z-index: 11; /* 确保关闭按钮在最上层 */
}

.close-btn:hover {
  background: #999;
}

.reservation_btn {
  bottom: 25px; /* 与抽奖按钮对齐的位置 */
  right: 140px;
  display: block;
  cursor: pointer;
  position: fixed;
  z-index: 10;
}


//.reservation-icon:hover {
//  background-color: #f5f5f5;
//}

/* 预约状态不改变背景色 */
.reservation-icon.reserved {
  /* 移除透明度或颜色变化 */
  opacity: 1;
  background-color: transparent;
}

.icon-container {
  position: relative;
  display: inline-block;
  margin-bottom: -15px; /* 减少图片底部间距 */
}

.activity-icon {
  //width: 40px;
  //height: 40px;
  object-fit: cover;
  margin-bottom: 2px; /* 调整图片与文字间距 */
  border-radius: 8px; /* 添加圆角 */
}

/* 显示原始尺寸的样式 */
.activity-icon.original-size {
  width: auto;
  height: auto;
  max-width: 160px;
  max-height: 160px;
}

/* 预约成功提示样式 */
.success-tip {
  position: absolute;
  top: 50px;
  right: 50px;
  background-color: #19be6b;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 12px;
  z-index: 10;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  animation: fadeInOut 3s ease-in-out;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: scale(0.8); }
  10% { opacity: 1; transform: scale(1); }
  90% { opacity: 1; transform: scale(1); }
  100% { opacity: 0; transform: scale(0.8); }
}

.activity-name {
  font-size: 13px; /* 调整字体大小 */
  color: #333;
  text-align: center;
  margin-top: 10px; /* 移除上边距 */
  line-height: 1.2; /* 调整行高 */
  font-weight: bold; /* 文字加粗 */
}



</style>



// WEBPACK FOOTER //
// src/components/Index.vue